import useEffectiveWorkflowRunFilters from '@UI/Pages/WorkflowRuns/Hooks/useEffectiveWorkflowRunFilters';
import workflowRunFiltersSignal, {
	setWorkflowRunFilters,
} from '@UI/Pages/WorkflowRuns/Filters/Signals/workflowRunFiltersSignal';
import formFieldStylesPt from '@UI/Pages/WorkflowRuns/Filters/Helpers/formFieldStylesPt';
import * as React from 'react';
import { Calendar } from '@verclam/ui-kit';

const CustomRangeFilter: React.FC = () => {
	const filters = useEffectiveWorkflowRunFilters();

	const customRangeValue = React.useMemo<(Date | null)[] | null>(() => {
		if (filters.startedFrom === null && filters.startedTo === null) {
			return null;
		}

		return [filters.startedFrom, filters.startedTo];
	}, [filters.startedFrom, filters.startedTo]);

	const handleCustomRangeChange = React.useCallback((value: (Date | null)[] | null) => {
		const [customFrom, customTo] = value ?? [null, null];
		setWorkflowRunFilters(
			workflowRunFiltersSignal.peek().setCustomRange(customFrom ?? null, customTo ?? null),
		);
	}, []);

	return (
		<Calendar<'range'>
			name="workflowRunCustomRange"
			label="Dates libres"
			placeholder="Du … au …"
			selectionMode="range"
			value={customRangeValue}
			onChange={handleCustomRangeChange}
			showIcon
			pt={formFieldStylesPt}
		/>
	);
};

export default CustomRangeFilter;
